import React, { useState, useEffect } from "react";

const BackgroundInfoSection = ({
  languages,
  languages1,
  selected,
  setSelected,
  selected1,
  setSelected1,
  erfNumber,
  setErfNumber,
  onSave,
  showError,
}) => {
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false); // New state for expand/collapse
  const [landSizes, setLandSizes] = useState({
    "Community Food garden allocation": { size: "", unit: "" },
    "Residential": { size: "", unit: "" },
    "Road side vacant land": { size: "", unit: "" },
    "Village / Local/ Tribunal Authority allocation": { size: "", unit: "" }
  });
  const [isErfFocused, setIsErfFocused] = useState(false);

  useEffect(() => {
    if (showError) {
      validateSection();
    }
  }, [showError]);

  useEffect(() => {
    if (selected || selected1 || erfNumber) {
      setError("");
    }
  }, [selected, selected1, erfNumber]);

  useEffect(() => {
    const landData = {
      type1: selected ? { 
        type: selected, 
        size: landSizes[selected]?.size || "", 
        unit: landSizes[selected]?.unit || "",
        hasLandSize: !!landSizes[selected]?.size 
      } : null,
      type2: selected1 ? { 
        type: selected1, 
        size: landSizes[selected1]?.size || "", 
        unit: landSizes[selected1]?.unit || "",
        hasLandSize: !!landSizes[selected1]?.size 
      } : null,
      erfNumber
    };
    
    onSave(landData);
  }, [selected, selected1, landSizes, erfNumber]);

  const validateSection = () => {
    if (!selected && !selected1 && !erfNumber) {
      setError("This section is required. Please select at least one land type or enter an ERF number.");
      return false;
    }
    setError("");
    return true;
  };

  const handleSizeChange = (type, e) => {
    const value = e.target.value;
    setLandSizes(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        size: value
      }
    }));
  };

  const handleErfChange = (e) => {
    setErfNumber(e.target.value);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      {/* Header with toggle button */}
      <div 
        className="w-full md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] md:mt-7 mt-3 relative cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="w-[154px] h-[70px] sm:w-[100px] sm:h-[100px]"></div>
        <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-center text-[8px] font-bold">
          LAND
          <p className="font-normal md:text-[32px] text-[8px]">Land for Agricultural activities</p>
        </div>
        <div className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black">
          <img
            src={`https://res.cloudinary.com/dzngpgki4/image/upload/${
              isExpanded 
                ? 'v1748785688/Expand_down_yilqh4.png' 
                : 'v1748785688/Expand_down_yilqh4.png'
            }`}
            alt="expand icon"
            className="md:w-12 md:h-12 w-6 h-6"
          />
        </div>
      </div>

      {/* Collapsible content */}
      {isExpanded && (
        <div className="animate-fadeIn">
          <div className="md:mt-3">
            <h1 className="md:text-[36px] text-[8px] font-bold">Agricultural interest</h1>
            <p className="md:text-[24px] italic font-light text-[6px] pl-2">
              Enter/type the size of Land and click
            </p>
          </div>
          
          {error && (
            <div className="text-red-600 text-xs mb-2">{error}</div>
          )}

          <div className="grid grid-cols-2 md:gap-2 gap-2 md:mt-4 mt-3">
            <div className="grid grid-cols-1 md:gap-2 gap-1">
              {languages.map((lang, i) => {
                const isActive = selected === lang;
                const isFoodGarden = lang.includes("Food garden allocation");
                const [mainLabel, subLabel] = isFoodGarden
                  ? ["Community", "Food garden allocation"]
                  : [lang, ""];
                return (
                  <div key={i}>
                    <button
                      onClick={() => setSelected(lang)}
                      disabled={lang === "-"}
                      className="flex items-center justify-between md:w-full w-[160px] md:h-[72px] h-[30px] bg-[#E7EBEB] border border-[#E7EBEB] rounded-[5px] md:pr-4 pr-2"
                    >
                      <div className="bg-[#E7EBEB] md:h-[72px] h-[30px] w-[80px] md:w-[328px] text-left inline md:pt-3 justify-center md:pl-6 pl-2 leading-[0.50] md:leading-[1.10]">
                        <span className="font-medium md:text-[28px] text-[6px] leading-tight">
                          {mainLabel}
                        </span>
                        {subLabel && (
                          <span className="font-normal md:text-[20px] text-[4px] md:pl-4 -mt-3 md:-mt-4">
                            {subLabel}
                          </span>
                        )}
                      </div>
                      <div className="flex md:space-x-8 space-x-2 items-center md:pr-10 pr-2">
                        <input
                          type="number"
                          placeholder="1"
                          value={isActive ? landSizes[lang]?.size || "" : ""}
                          onChange={(e) => handleSizeChange(lang, e)}
                          className="bg-transparent text-black bg-[#E7EBEB] placeholder-black md:text-[32px] text-[8px] outline-none border-none text-center font-bold underline md:w-24 w-8 focus:outline-none"
                        />
                        <h1 className="md:text-[32px] text-[8px] text-black font-bold">Ha</h1>
                      </div>
                      <span
                        className={`md:w-14 md:h-14 w-4 h-4 rounded-full 
                          ${
                            isActive
                              ? "bg-[#2E453D] md:border-[8px] border-[3px] border-white"
                              : "md:border-[8px] border-[3px] border-white bg-transparent"
                          }`}
                      />
                    </button>
                  </div>
                );
              })}
            </div>
            
            <div>
              <div className="grid grid-cols-1 md:gap-[135px] gap-4">
                {languages1.map((lang, i) => {
                  const isActive = selected1 === lang;
                  let mainLabel = lang;
                  let subLabel = "";
                  if (lang.includes("vacant land")) {
                    mainLabel = "Road side";
                    subLabel = "vacant land";
                  } else if (lang.includes("Local/ Tribunal Authority allocation")) {
                    mainLabel = "Village /";
                    subLabel = "Local/ Tribunal Authority allocation";
                  }
                  return (
                    <div key={i}>
                      <button
                        onClick={() => setSelected1(lang)}
                        disabled={lang === "-"}
                        className="flex items-center justify-between md:w-full w-[160px] md:h-[72px] h-[30px] bg-[#E7EBEB] border border-[#E7EBEB] rounded-[5px] md:pr-4 pr-2"
                      >
                        <div className="bg-[#E7EBEB] md:h-[72px] md:w-[328px] h-[30px] w-[80px] text-left inline md:pt-3 leading-[0.50] md:leading-[1.00] md:pl-6 pl-2">
                          <span className="font-medium md:text-[28px] text-[6px] leading-tight">
                            {mainLabel}
                          </span>
                          {subLabel && (
                            <span className="font-normal md:text-[20px] text-[4px]">
                              {subLabel}
                            </span>
                          )}
                        </div>
                        <div className="flex md:space-x-12 space-x-2 items-center md:pr-10 pr-2">
                          <input
                            type="number"
                            placeholder="1"
                            value={isActive ? landSizes[lang]?.size || "" : ""}
                            onChange={(e) => handleSizeChange(lang, e)}
                            className="bg-transparent text-black bg-[#E7EBEB] placeholder-black md:text-[32px] text-[8px] outline-none border-none text-center font-bold underline md:w-24 w-8 focus:outline-none"
                          />
                          <h1 className="md:text-[32px] text-[8px] text-black font-bold">Ha</h1>
                        </div>
                        <span
                          className={`md:w-14 md:h-14 w-4 h-4 rounded-full 
                            ${
                              isActive
                                ? "bg-[#2E453D] md:border-[8px] border-[3px] border-white"
                                : "md:border-[8px] border-[3px] border-white bg-transparent"
                            }`}
                        />
                      </button>
                    </div>
                  );
                })}
              </div>
              
              <div>
                <button
                  type="button"
                  className="flex items-center justify-between md:mt-6 mt-8 w-[160px] md:w-full md:h-[72px] h-[30px] bg-[#2E453D] border border-[#E7EBEB] rounded-[5px] md:pr-4"
                >
                  <div className="bg-[#E7EBEB] md:h-[72px] h-[30px] w-[80px] md:w-[328px] text-left inline md:pt-3 pt-1 leading-[1.00] md:pl-6 pl-1">
                    <span className="font-medium md:text-[32px] text-[6px] leading-tight">
                      Land Registration No
                    </span>
                  </div>
                  <div className="flex md:space-x-12 space-x-2 items-center pr-2">
                    <input
                      type="text"
                      value={erfNumber || ""}
                      onChange={handleErfChange}
                      onFocus={() => setIsErfFocused(true)}
                      onBlur={() => setIsErfFocused(false)}
                      placeholder={!isErfFocused && !erfNumber ? "XXXXX" : ""}
                      className="bg-transparent text-white text-center placeholder:text-white bg-[#2E453D] border-none outline-transparent font-medium md:w-[200px] w-[60px] underline md:text-[32px] text-[8px] focus:outline-none"
                    />
                  </div>
                  <span />
                </button>
              </div>
              
              <p className="md:text-[16px] text-[6px] font-light italic mt-1">
                Enter Land registration number
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BackgroundInfoSection;